const {
    product,
    // Nguyen added start
    product_default_mtf,
    // Nguyen added end
    strings: { add_to_cart: TEXT_ATC, update_cart: TEXT_UPDATE_CART },
    routes: { type: currentPageType },
} = konfigurator_data.conf;
console.log(product_default_mtf, "==-product_default_mtf");

const {
    id: productId,
    handle: productHandle,
    variants: [variantSelected],
    price: productPrice,
} = product;

const CONSTAN = {
    mainPrice: ".product__price:not(.product__price--compare)",
};
const utils = {
    getProductType: () => {
        let type = "jacket";
        if (productHandle.includes("pants")) {
            type = "pants";
        }
        if (productHandle.includes("vest")) {
            type = "vest";
        }
        if (window.konfigurator_data.SUIT_MAP[productHandle]) {
            type = "suit";
        }

        return type;
    },
    getProductUrl: () => {
        if (!window.konfigurator_data.SUIT_MAP) {
            return false;
        }

        let result = window.konfigurator_data.URL_MAP[productHandle];

        if (getProductType === "suit") {
            result = window.konfigurator_data.SUIT_MAP[productHandle].jacket + "&multistage=first";
        }

        // if (dev) {
        //   result = result.replace("https://3dk.tronog-engine.com/konfigurator", "http://192.168.10.212:4203/");
        // }
        return result;
    },
};

const getProductType = utils.getProductType();

// SOMEBODY CLEARS WHOLE LOALSTORAGE BEFORE WE GET TO LOAD IT,
// SO WE NEED TO LOAD IT IMMEDIATELY
let STATE_SUIT = null;
let STATE_PRODUCT = null;

// variable that overrides SUIT URLs for wedding planner
// window.KONFIGURATOR_JUMP_SUIT
const jacketKeys = [];
let pantsDefaultData = [];
if (getProductType == "suit") {
    const pantsKey = 'Waistband,Pleats,Pants Pockets,Rear Pockets,Hem Style,Leg Lining,Tuxedo Stripe,Suspender Buttons,Waistband Height'.split(',');
    const konfInputsDefault = document.querySelectorAll("#konfiguratorProperties input[data-konf-default]");
    pantsDefaultData = [...konfInputsDefault]
        .filter((input) => {
            const isExist = pantsKey.find(key => {
                return input.name.toLowerCase().includes(key.trim().toLowerCase());
            })
            return !!isExist;
        })
        .map((input) => {
            const key = input.name.match(/\[(.*?)\]/)[1]; // Dinner Split
            return {
                label: key.trim() + ": " + input.value,
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        });
        console.log('pantsDefaultData::', pantsDefaultData);
}

let Konfigurator = () => {
    let exported = {
        toggleKonfigurator,
        onMessage: (data) => {},
        onOrderClick,
        snapshot,
        onSnapshot,
        resetSelection,
        resetAllSelection,
        resetAllSelections,
        onProductDetails: (productDetails) => {},
        setProductDetails,
        getState,
    };

    let dev = false;
    let REPLACEMENTS = {
        Button_Textured: "Button",
        ButtonTuxedo: "Tuxedo Satin",
        MainMaterial: "Fabric",
        Mainmaterial: "Fabric",
        "Sleeve Cuffs": "Cuffs",
        "Button Placement": "Sleeve Button Spacing",
    };
    let IGNORE = {
        "Mainmat or satin": !0,
        ButtonTuxedo: !0,
        Stitching: !0,
        Stitch: !0,
    };
    let VAR_MAP = {
        jacket_style: {
            single_breasted_one_button: "Single Breasted - One button",
            single_breasted_two_button: "Single Breasted - Two button",
            single_breasted_three_button: "Single Breasted - Three Button",
            double_breasted_four_button: "Double Breasted - Four Button",
            double_breasted_six_button: "Double Breasted - Six Button",
        },
        lapel: {
            notch_narrow: "Narrow Notch",
            notch_regular: "Regular Notch",
            notch_wide: "Wide Notch",
            shawl_narrow: "Narrow Shawl",
            shawl_regular: "Regular Shawl",
            shawl_wide: "Wide Shawl",
            peak_narrow: "Narrow Peak",
            peak_regular: "Regular Peak",
            peak_wide: "Wide Peak",
        },
        pick_stitching: {
            regular: "Regular",
            pick: "Pick",
            top: "Top",
        },
        canvas: {
            unstructured: "Unstructured",
            half: "Half",
            full: "Full",
        },
        shoulder_type: {
            standard: "Standard",
            roped: "Roped",
            soft: "Soft",
        },
        side_pockets: {
            patch: "patch",
            standard: "Standard",
            soft: "Soft",
            angled: "Angled",
            standard: "Standard",
            angled: "Angled",
            straight: "Straight",
            angled: "Angled",
        },
        ticket_pocket: {
            none: "None",
            no: "No",
            yes: "Yes",
        },
        chest_pocket: {
            yes: "Yes",
            no: "No",
            none: "None",
            standard: "Standard",
        },
        vents: {
            single: "Single",
            dual: "Double",
            none: "None",
        },
        sleeve_buttons: {
            one: "One",
            two: "Two",
            three: "Three",
            four: "Four",
            five: "Five",
            functional_one: "One",
            functional_two: "Two",
            functional_three: "Three",
            functional_four: "Four",
            functional_five: "Five",
        },
        functionality: {
            functional: "Functional",
            non_functional: "Non Functional",
        },
        spacing_bar: {
            spaced: "Spaced",
            kissing: "Kissing",
            stacked: "Stacked",
        },
        piping: {
            green: "Green",
            brown: "Brown",
            blue: "Blue",
            black: "Black",
            pink: "Pink",
            purple: "Purple",
            sartoro: "Sartoro",
            yellow: "Gold",
            orange: "Orange",
            red: "Red",
            grey: "Grey",
            white: "White",
            none: "None",
        },
        style: {
            three: "Single Breasted - Three Button",
            four: "Single Breasted - Four Button",
            five: "Single Breasted - Five Button",
            six: "Single Breasted - Six Button",
            seven: "Single Breasted - Seven Button",
            db_six: "Double Breasted - Six Button",
            db_eight: "Double Breasted - Eight Button",
        },
        neck: {
            normal: "Standard",
            scoop: "Scoop",
            notch: "Notch Lapels",
            peaked: "Peak Lapels",
            shawl: "Shawl Lapels",
        },
        ticket_pocket: {
            yes: "Yes",
            no: "No",
        },
        pleats: {
            flat_front: "Flat Front",
            single_pleat: "Single Pleat",
            double_pleats: "Double Pleats",
        },
        suspender_buttons: {
            yes: "Yes",
            no: "No",
        },
        waist_band: {
            belt_loops: "Belt Loops",
            side_tabs: "Side Tabs",
            none: "None",
        },
        dinner_split: {
            standard: "No",
            dinner_split: "Yes",
        },
        rear_pockets: {
            dual: "Dual",
            right: "Right",
            left: "Left",
            none: "None",
        },
        hem: {
            cuffed: "Cuffed",
            blind_hem: "Blind Hem",
            unhemmed: "Unhemmed",
        },
        length: {
            no_break: "No Break",
            half_break: "Half Break",
            ankle_flash: "Ankle Flash",
        },
        tuxedo_stripes: {
            with: "With",
            without: "Without",
        },
    };
    let ADVANCED_DEFAULTS = {
        pick_stitching: "regular",
        canvas: "half",
        shoulder_type: "standard",
        ticket_pocket: "none",
        chest_pocket: "standard",
        spacing_bar: "kissing",
        waist_band: "side_tabs",
        functionality: "standard",
    };
    let DELETE_LIST = [
        "properties[Lining]",
        "properties[Button_Textured]",
        "properties[Button Textured]",
        "properties[ButtonTextured]",
        "properties[ButtonTuxedo]",
        "properties[Button Tuxedo]",
        "properties[Material]",
        "properties[MainMaterial]",
        "properties[MainMat_OR_Satin]",
        "properties[Stitch]",
        "properties[Jacket Style]",
        "properties[Lapels]",
        "properties[Stitching]",
        "properties[Side Pockets]",
        "properties[Chest Pocket]",
        "properties[Vents]",
        "properties[Sleeve Cuffs]",
        "properties[Sleeve Buttons]",
        "properties[Button Placement]",
    ];
    let konfigurator = false;
    let originalPrice = variantSelected.price;

    let imageSrc = null;
    let cartImages = {};
    let replacedImages = {};
    let suit = {
        phase: "jacket",
        jacket: {
            state: {},
        },
        pants: {
            state: {},
        },
    };

    // ALL LINE ITEMS THAT ARE SENT TO SHOPIFY
    // EVERY HAS A FORMAT:
    // VARIABLE: VALUE
    // Fabric: 1301 - Satin Blue
    let selected = []; // string[]
    let state = {};

    function init() {
        // var style = document.createElement("link");
        // style.href = "https://sartoro.tronog-engine.com/frontend.css";
        // style.rel = "stylesheet";
        // window.head && window.head.appendChild(style)

        currentPageType != "cart" &&
            window.addEventListener("message", (data) => {
                parseMessage(data);
            });

        if (window.bcpo && window.bcpo.$) {
            console.log("bcpo found");

            // $(document).on("bcpo:beforeAddToCart", beforeAddToCart);
            window.bcpo.$(document).on("bcpo:beforeCheckout", beforeCheckout);
        } else {
            console.log("bcpo not found");

            if (typeof window.$ === "function") {
                $(document).on("bcpo:beforeCheckout", beforeCheckout);
            }
        }

        if (getProductType == "suit") {
            if (STATE_SUIT) {
                try {
                    let rawState = STATE_SUIT;
                    let s = JSON.parse(rawState);

                    suit["jacket"] = s.jacket;
                    suit["pants"] = s.pants;

                    suit["jacket"].state.activeMaterialLinks = new Set(suit["jacket"].state.activeMaterialLinks);
                    suit["pants"].state.activeMaterialLinks = new Set(suit["pants"].state.activeMaterialLinks);
                } catch (e) {
                    console.log("error :>> ", e);
                }

                try {
                    state = suit["jacket"].state;
                    parseState();
                    renderProductProperties();
                } catch (error) {
                    console.log("error :>> parseState", error);
                }
            }
        } else {
            try {
                let rawState = STATE_PRODUCT;
                let s = JSON.parse(rawState);
                state = s;
                parseState();
                renderProductProperties();
            } catch (error) {}
        }

        console.log("state::", state);

        const configureButtons = document.querySelectorAll(".js-configure");
        console.log(configureButtons, "==-configureButtons");

        if (configureButtons.length > 0) {
            // Remove hidden class immediately when element is found
            configureButtons.forEach((configureButton) => {
                configureButton.classList.remove("lding");
            });
            document.querySelectorAll("product-container button.add-to-cart").forEach((button) => button.classList.remove("disabled"));
        }

        let configureClicked = false; // Limit scope within init function

        document.addEventListener("click", async (e) => {
            const { target } = e;

            if (target.closest(".js-konfigurator-reset")) {
                e.preventDefault();
                e.stopPropagation();

                resetAllSelection();
                await window.theme.localforage.removeItem("sartoro_suit_" + productHandle);
                await window.theme.localforage.removeItem("sartoro_" + productHandle);

                setTimeout(() => {
                    // wait for iframe to reset
                    window.dispatchEvent(new CustomEvent("konfigurator:reset-selection"));
                }, 100);
            }

            if (target.closest(".js-configure") || target.closest(".js-konfigurator-btn")) {
                e.preventDefault();
                e.stopPropagation();
                if (!configureClicked) {
                    // First click
                    configureClicked = true;
                    registerIframeListener();
                    toggleKonfigurator();
                } else {
                    // Subsequent clicks
                    toggleKonfigurator();
                }
            }
        });

        document.dispatchEvent(new Event("theme:konfigurator_frontend:loaded"));
    }

    function beforeCheckout(e, data) {
        // const data = e.detail;
        if (window.doingCheckout) return;
        window.doingCheckout = true;
        document.querySelectorAll('[name="checkout"]').forEach((i) => {
            console.log("---> konfigurator::", i);

            i.classList.add("btn--loading");
        });

        if (window.DT3oTool && typeof DT3oTool.setLoadingCloneBtnWithVOPO === 'function') {
            DT3oTool.setLoadingCloneBtnWithVOPO(true);
        }

        let idx = 0;

        data.items.forEach((item, index) => {
            if (cartImages[idx]) {
                item.featured_image.url = cartImages[idx];
                item.featured_image.width = 1280;
                item.featured_image.height = 1920;
                item.image = cartImages[idx];
            }
            let props = item.properties;
            item.properties = {};

            for (let key in props) {
                // console.log("key::", key);
                if (key == "image") {
                    continue;
                }
                // let price = 0;

                if (!props[key]) return;
                if (props[key].toString().includes(" | ")) {
                    price = props[key].toString().split(" | ")[1].trim();
                }
                // item.properties[key] = props[key].split(" | ")[0].trim();
                item.properties[key] = props[key].toString().trim();
            }
        });
    }

    function beforeAddToCart(e) {
        const formData = e.detail;
        // const fieldName = 'properties[_spo_option_settings]';
        // const kon_price_add_ons = formData.get('properties[_hidden-price-add-ons]');

        // if (formData.has(fieldName)) {

        // } else {
        //     const fieldValue = JSON.stringify([{ id: '', label: '', type: '', value: '', price_adjustment: parseInt(kon_price_add_ons) }]);
        //     formData.append(fieldName, fieldValue);
        //     formData.delete('properties[_hidden-price-add-ons]');
        // }

        // try {
        //     if (!state.orderData) {
        //         return;
        //     }
        //     if (!utils.getProductUrl()) {
        //         return;
        //     }
        //     DELETE_LIST.forEach((item) => {
        //         if (data.has(item)) {
        //             data.delete(item);
        //         }
        //     });

        //     let _selected = selected;
        //     selected = [];
        //     _selected.forEach((item) => {
        //         let variable = item.label.split(": ")[0];
        //         let value = item.label.split(": ")[1].split("|")[0];
        //         if (IGNORE[variable]) {
        //             return;
        //         }
        //         if (REPLACEMENTS[variable]) {
        //             variable = REPLACEMENTS[variable];
        //         }
        //         item.label = variable + ": " + value;
        //     });
        //     selected = generateCartItems(_selected);
        //     selected.forEach((item) => {
        //         if (!item) {
        //             return;
        //         }
        //         let variable = item.label.split(": ")[0].split("|")[0];
        //         let price = "";
        //         console.log("_ITEM", item);
        //         if (item.price) {
        //             if (typeof item.price.valueUSD != "undefined") {
        //                 if (item.price.valueUSD) {
        //                     price = " | $" + Math.floor(getMarketPrice(+item.price.valueUSD));
        //                     price = price.includes(".") ? price : price + ".00";
        //                 }
        //             } else {
        //                 if (item.price) {
        //                     price = " | $" + Math.floor(getMarketPrice(+item.price));
        //                     price = price.includes(".") ? price : price + ".00";
        //                 }
        //             }
        //         }
        //         let value = item.label.split(": ")[1] + price;
        //         if (item.label.split(": ")[0]) {
        //             data.set("properties[" + variable + "]", value);
        //         }
        //         console.log("_PRICE", price);
        //     });
        // } catch (e) {}
    }

    function generateCartItems(_selected) {
        let selected = [];
        try {
            switch (getProductType) {
                case "jacket":
                    selected = generateCartItemsJacket(_selected);
                    break;
                case "pants":
                    selected = generateCartItemsPants(_selected);
                    break;
                case "vest":
                    selected = generateCartItemsVest(_selected);
                    break;
                case "suit":
                    selected = generateCartItemsSuit(_selected);
                    break;
            }
        } catch (error) {
            console.log("error :>> generateCartItems", error);
        }
        return selected;
    }

    function generateCartItemsJacket(_selected) {
        let selected = [];
        if (!state.orderData.functionality) {
            state.orderData.functionality = {
                label: "functional",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.piping) {
            state.orderData.piping = {
                label: "sartoro",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.side_pockets) {
            state.orderData.side_pockets = {
                label: "standard",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.ticket_pocket) {
            state.orderData.ticket_pocket = {
                label: "none",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.sleeve_buttons) {
            state.orderData.sleeve_buttons = {
                label: "two",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.spacing_bar) {
            state.orderData.spacing_bar = {
                label: "spaced",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.canvas) {
            state.orderData.canvas = {
                label: "half",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.chest_pocket) {
            state.orderData.chest_pocket = {
                label: "yes",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.pick_stitching) {
            state.orderData.pick_stitching = {
                label: "regular",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.shoulder_type) {
            state.orderData.shoulder_type = {
                label: "standard",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.vents) {
            state.orderData.vents = {
                label: "dual",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        selected.push({
            label: "Fabric: " + state.colors.I.selectedLabel,
            price: state.colors.I.pricing,
        });
        selected.push({
            label: "Jacket Style: " + VAR_MAP.jacket_style[state.orderData.jacket_style.label],
            price: state.orderData.jacket_style.price,
        });
        if (state.orderData.sartorotuxedo) {
            //console.log("_ST1", state.orderData.sartorotuxedo);
            selected.push({
                label: "Tuxedo Satin: " + state.orderData.sartorotuxedo.label,
                price: state.orderData.sartorotuxedo.price,
            });
        } else {
            if (state.colors.I.selectedLabel != state.colors.VI.selectedLabel) {
                //console.log("_ST2", state.colors.VI);
                selected.push({
                    label: "Tuxedo Satin: " + state.colors.VI.selectedLabel,
                    price: state.colors.VI.pricing,
                });
            }
        }
        selected.push({
            label: "Lining: " + state.colors.II.selectedLabel,
            price: state.colors.II.pricing,
        });
        if (state.activeMaterialLinks.has("IX")) {
            selected.push({
                label: "Buttons: " + state.colors.IX.selectedLabel,
                price: state.colors.IX.pricing,
            });
        }
        if (state.activeMaterialLinks.has("X")) {
            selected.push({
                label: "Buttons: " + state.colors.X.selectedLabel,
                price: state.colors.X.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XI")) {
            selected.push({
                label: "Buttons: " + state.colors.XI.selectedLabel,
                price: state.colors.XI.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XII")) {
            selected.push({
                label: "Buttons: " + state.colors.XII.selectedLabel,
                price: state.colors.XII.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XIII")) {
            selected.push({
                label: "Buttons: " + state.colors.XIII.selectedLabel,
                price: state.colors.XIII.pricing,
            });
        }
        selected.push({
            label: "Lapels: " + VAR_MAP.lapel[state.orderData.lapel.label],
            price: state.orderData.lapel.price,
        });
        selected.push({
            label: "Side Pockets: " + VAR_MAP.side_pockets[state.orderData.side_pockets.label],
            price: state.orderData.side_pockets.price,
        });
        if (state.orderData.ticket_pocket.label != ADVANCED_DEFAULTS.ticket_pocket) {
            selected.push({
                label: "Ticket Pocket: " + VAR_MAP.ticket_pocket[state.orderData.ticket_pocket.label],
                price: state.orderData.ticket_pocket.price,
            });
        }
        selected.push({
            label:
                "Cuffs: " +
                VAR_MAP.functionality[state.orderData.functionality.label] +
                ", " +
                VAR_MAP.sleeve_buttons[state.orderData.sleeve_buttons.label] +
                ", " +
                VAR_MAP.spacing_bar[state.orderData.spacing_bar.label],
            price: state.orderData.sleeve_buttons.price,
        });
        selected.push({
            label: "Piping: " + VAR_MAP.piping[state.orderData.piping.label],
            price: state.orderData.piping.price,
        });
        if (state.orderData.canvas.label != ADVANCED_DEFAULTS.canvas) {
            selected.push({
                label: "Canvas: " + VAR_MAP.canvas[state.orderData.canvas.label],
                price: state.orderData.canvas.price,
            });
        }
        if (state.orderData.chest_pocket.label != ADVANCED_DEFAULTS.chest_pocket) {
            selected.push({
                label: "Chest Pocket: " + VAR_MAP.chest_pocket[state.orderData.chest_pocket.label],
                price: state.orderData.chest_pocket.price,
            });
        }
        if (state.orderData.pick_stitching.label != ADVANCED_DEFAULTS.pick_stitching) {
            selected.push({
                label: "Stitching: " + VAR_MAP.pick_stitching[state.orderData.pick_stitching.label],
                price: state.orderData.pick_stitching.price,
            });
        }
        if (state.orderData.shoulder_type.label != ADVANCED_DEFAULTS.shoulder_type) {
            selected.push({
                label: "Shoulder: " + VAR_MAP.shoulder_type[state.orderData.shoulder_type.label],
                price: state.orderData.shoulder_type.price,
            });
        }
        selected.push({
            label: "Vents: " + VAR_MAP.vents[state.orderData.vents.label],
            price: state.orderData.vents.price,
        });
        if (state.orderData.monogram) {
            if (state.orderData.monogram.label == null) {
            } else if (state.orderData.monogram.label == "null") {
            } else if (state.orderData.monogram.label == "none") {
            } else if (state.orderData.monogram.label == "None") {
            } else if (state.orderData.monogram.label != "") {
                selected.push({
                    label: "Monogram: " + state.orderData.monogram.label,
                    price: state.orderData.monogram.price,
                });
            }
        }
        return selected;
    }

    function generateCartItemsPants(_selected) {
        let selected = [];
        selected.push({
            label: "Fabric: " + state.colors.I.selectedLabel,
            price: state.colors.I.pricing,
        });
        if (state.activeMaterialLinks.has("IX")) {
            selected.push({
                label: "Buttons: " + state.colors.IX.selectedLabel,
                price: state.colors.IX.pricing,
            });
        }
        if (state.activeMaterialLinks.has("V")) {
            selected.push({
                label: "Buttons: " + state.colors.V.selectedLabel,
                price: state.colors.V.pricing,
            });
        }
        if (state.activeMaterialLinks.has("X")) {
            selected.push({
                label: "Buttons: " + state.colors.X.selectedLabel,
                price: state.colors.X.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XI")) {
            selected.push({
                label: "Buttons: " + state.colors.XI.selectedLabel,
                price: state.colors.XI.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XII")) {
            selected.push({
                label: "Buttons: " + state.colors.XII.selectedLabel,
                price: state.colors.XII.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XIII")) {
            selected.push({
                label: "Buttons: " + state.colors.XIII.selectedLabel,
                price: state.colors.XIII.pricing,
            });
        }
        if (state.activeMaterialLinks.has("VIII")) {
        }
        if (VAR_MAP.pleats[state.orderData.pleats.label] !== undefined) {
            selected.push({
                label: "Pleats: " + VAR_MAP.pleats[state.orderData.pleats.label],
                price: state.orderData.pleats.price,
            });
        }
        if (state.orderData.suspender_buttons) {
            selected.push({
                label: "Suspender Buttons: " + VAR_MAP.suspender_buttons[state.orderData.suspender_buttons.label],
                price: state.orderData.suspender_buttons.price,
            });
        }
        if (!state.orderData.waist_band) {
            state.orderData.waist_band = {
                label: "side_tabs",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        selected.push({
            label: "Waistband: " + VAR_MAP.waist_band[state.orderData.waist_band.label],
            price: state.orderData.waist_band.price,
        });
        selected.push({
            label: "Dinner Split: " + VAR_MAP.dinner_split[state.orderData.dinner_split.label],
            price: state.orderData.dinner_split.price,
        });
        selected.push({
            label: "Pants Pockets: " + VAR_MAP.side_pockets[state.orderData.side_pockets.label],
            price: state.orderData.side_pockets.price,
        });
        selected.push({
            label: "Rear Pockets: " + VAR_MAP.rear_pockets[state.orderData.rear_pockets.label],
            price: state.orderData.rear_pockets.price,
        });
        selected.push({
            label: "Hem: " + VAR_MAP.hem[state.orderData.hem.label],
            price: state.orderData.hem.price,
        });
        if (state.orderData.hem.label !== "unhemmed") {
            selected.push({
                label: "Length: " + VAR_MAP.length[state.orderData.length.label],
                price: state.orderData.length.price,
            });
        }
        if (state.orderData.tuxedo_stripes.label == "with") {
            selected.push({
                label: "Tuxedo Stripe: Yes",
                price: state.colors.VIII.pricing,
            });
        }
        return selected;
    }

    function generateCartItemsVest(_selected) {
        let selected = [];
        if (state.activeMaterialLinks.has("IV")) {
            selected.push({
                label: "Fabric: " + state.colors.IV.selectedLabel,
                price: state.colors.IV.pricing,
            });
        } else {
            selected.push({
                label: "Fabric: " + state.colors.I.selectedLabel,
                price: state.colors.I.pricing,
            });
        }
        if (state.activeMaterialLinks.has("II")) {
            selected.push({
                label: "Buttons: " + state.colors.II.selectedLabel,
                price: state.colors.II.pricing,
            });
        }
        if (state.activeMaterialLinks.has("IX")) {
            selected.push({
                label: "Buttons: " + state.colors.IX.selectedLabel,
                price: state.colors.IX.pricing,
            });
        }
        if (state.activeMaterialLinks.has("VI")) {
            selected.push({
                label: "Buttons: " + state.colors.VI.selectedLabel,
                price: state.colors.VI.pricing,
            });
        }
        if (state.activeMaterialLinks.has("VII")) {
            selected.push({
                label: "Buttons: " + state.colors.VII.selectedLabel,
                price: state.colors.VII.pricing,
            });
        }
        if (state.activeMaterialLinks.has("VIII")) {
            selected.push({
                label: "Buttons: " + state.colors.VIII.selectedLabel,
                price: state.colors.VIII.pricing,
            });
        }
        if (state.activeMaterialLinks.has("X")) {
            selected.push({
                label: "Buttons: " + state.colors.X.selectedLabel,
                price: state.colors.X.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XI")) {
            selected.push({
                label: "Buttons: " + state.colors.XI.selectedLabel,
                price: state.colors.XI.pricing,
            });
        }
        if (state.activeMaterialLinks.has("XIV")) {
            selected.push({
                label: "Lining: " + state.colors.XIV.selectedLabel,
                price: state.colors.XIV.pricing,
            });
        }
        if (state.activeMaterialLinks.has("V")) {
            selected.push({
                label: "Vest Backing: " + state.colors.V.selectedLabel,
                price: state.colors.V.pricing,
            });
        }
        if (!state.orderData.neck) {
            state.orderData.neck = {
                label: "normal",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        selected.push({
            label: "Style: " + VAR_MAP.style[state.orderData.style.label],
            price: state.orderData.style.price,
        });
        selected.push({
            label: "Neck: " + VAR_MAP.neck[state.orderData.neck.label],
            price: state.orderData.neck.price,
        });
        selected.push({
            label: "Side pockets: " + VAR_MAP.side_pockets[state.orderData.side_pockets.label],
            price: state.orderData.side_pockets.price,
        });
        selected.push({
            label: "Chest pocket: " + VAR_MAP.chest_pocket[state.orderData.chest_pocket.label],
            price: state.orderData.chest_pocket.price,
        });
        return selected;
    }

    function generateCartItemsSuit(_selected) {
        let selected = [];
        selected.push({
            label: "Fabric: " + suit.jacket.state.colors.I.selectedLabel,
            price: suit.jacket.state.colors.I.pricing,
        });
        jacketKeys.push("Fabric");
        if (!Object.keys(suit.jacket.state.orderData).length) {
            console.log("Ignoring, empty oderData");
            return [];
        }
        selected.push({
            label: "Jacket Style: " + VAR_MAP.jacket_style[suit.jacket.state.orderData.jacket_style.label],
            price: suit.jacket.state.orderData.jacket_style.price,
        });
        jacketKeys.push("Jacket Style");
        if (suit.jacket.state.orderData.sartorotuxedo) {
            let _price = "";
            if (suit.jacket.state.orderData.sartorotuxedo.price != "") {
                _price = suit.jacket.state.orderData.sartorotuxedo.price.valueUSD;
            }
            if (suit.jacket.state.colors.VI.pricing !== "") {
                if (_price == "") {
                    _price = suit.jacket.state.colors.VI.pricing.valueUSD;
                }
            }
            //console.log("_ST3", _price);
            selected.push({
                label: "Tuxedo Satin: " + suit.jacket.state.orderData.sartorotuxedo.label,
                price: _price,
            });
            jacketKeys.push("Tuxedo Satin");
        } else {
            if (suit.jacket.state.colors.I.selectedLabel != suit.jacket.state.colors.VI.selectedLabel) {
                //console.log("_ST4", suit.jacket.state.colors.VI);
                selected.push({
                    label: "Tuxedo Satin: " + suit.jacket.state.colors.VI.selectedLabel,
                    price: suit.jacket.state.colors.VI.pricing,
                });
                jacketKeys.push("Tuxedo Satin");
            }
        }
        selected.push({
            label: "Lining: " + suit.jacket.state.colors.II.selectedLabel,
            price: suit.jacket.state.colors.II.pricing,
        });
        jacketKeys.push("Lining");
        if (suit.jacket.state.activeMaterialLinks.has("IX")) {
            selected.push({
                label: "Buttons: " + suit.jacket.state.colors.IX.selectedLabel,
                price: suit.jacket.state.colors.IX.pricing,
            });
            jacketKeys.push("Buttons");
        }
        if (suit.jacket.state.activeMaterialLinks.has("X")) {
            selected.push({
                label: "Buttons: " + suit.jacket.state.colors.X.selectedLabel,
                price: suit.jacket.state.colors.X.pricing,
            });
            jacketKeys.push("Buttons");
        }
        if (suit.jacket.state.activeMaterialLinks.has("XI")) {
            selected.push({
                label: "Buttons: " + suit.jacket.state.colors.XI.selectedLabel,
                price: suit.jacket.state.colors.XI.pricing,
            });
            jacketKeys.push("Buttons");
        }
        if (suit.jacket.state.activeMaterialLinks.has("XII")) {
            selected.push({
                label: "Buttons: " + suit.jacket.state.colors.XII.selectedLabel,
                price: suit.jacket.state.colors.XII.pricing,
            });
            jacketKeys.push("Buttons");
        }
        if (suit.jacket.state.activeMaterialLinks.has("XIII")) {
            selected.push({
                label: "Buttons: " + suit.jacket.state.colors.XIII.selectedLabel,
                price: suit.jacket.state.colors.XIII.pricing,
            });
            jacketKeys.push("Buttons");
        }
        selected.push({
            label: "Lapels: " + VAR_MAP.lapel[suit.jacket.state.orderData.lapel.label],
            price: suit.jacket.state.orderData.lapel.price,
        });
        jacketKeys.push("Lapels");
        selected.push({
            label: "Side Pockets: " + VAR_MAP.side_pockets[suit.jacket.state.orderData.side_pockets.label],
            price: suit.jacket.state.orderData.side_pockets.price,
        });
        jacketKeys.push("Side Pockets");
        if (suit.jacket.state.orderData.ticket_pocket.label != ADVANCED_DEFAULTS.ticket_pocket) {
            selected.push({
                label: "Ticket Pocket: " + VAR_MAP.ticket_pocket[suit.jacket.state.orderData.ticket_pocket.label],
                price: suit.jacket.state.orderData.ticket_pocket.price,
            });
        }
        jacketKeys.push("Ticket Pocket");
        if (!state.orderData.functionality) {
            state.orderData.functionality = {
                label: "functional",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        if (!state.orderData.piping) {
            state.orderData.piping = {
                label: "sartoro",
                price: {
                    valueEUR: "",
                    valueUSD: "",
                },
            };
        }
        selected.push({
            label:
                "Cuffs: " +
                VAR_MAP.functionality[suit.jacket.state.orderData.functionality.label] +
                ", " +
                VAR_MAP.sleeve_buttons[suit.jacket.state.orderData.sleeve_buttons.label] +
                ", " +
                VAR_MAP.spacing_bar[suit.jacket.state.orderData.spacing_bar.label],
            price: suit.jacket.state.orderData.sleeve_buttons.price,
        });
        jacketKeys.push("Cuffs");
        selected.push({
            label: "Piping: " + VAR_MAP.piping[suit.jacket.state.orderData.piping.label],
            price: suit.jacket.state.orderData.piping.price,
        });
        jacketKeys.push("Piping");
        if (suit.jacket.state.orderData.canvas.label != ADVANCED_DEFAULTS.canvas) {
            selected.push({
                label: "Canvas: " + VAR_MAP.canvas[suit.jacket.state.orderData.canvas.label],
                price: suit.jacket.state.orderData.canvas.price,
            });
            jacketKeys.push("Canvas");
        }
        if (typeof suit.jacket.state.orderData.chest_pocket.label === "undefined") {
            suit.jacket.state.orderData.chest_pocket.label = ADVANCED_DEFAULTS.chest_pocket;
        }
        if (suit.jacket.state.orderData.chest_pocket.label != ADVANCED_DEFAULTS.chest_pocket) {
            selected.push({
                label: "Chest Pocket: " + VAR_MAP.chest_pocket[suit.jacket.state.orderData.chest_pocket.label],
                price: suit.jacket.state.orderData.chest_pocket.price,
            });
            jacketKeys.push("Chest Pocket");
        }
        if (suit.jacket.state.orderData.pick_stitching.label != ADVANCED_DEFAULTS.pick_stitching) {
            selected.push({
                label: "Stitching: " + VAR_MAP.pick_stitching[suit.jacket.state.orderData.pick_stitching.label],
                price: suit.jacket.state.orderData.pick_stitching.price,
            });
            jacketKeys.push("Stitching");
        }
        if (suit.jacket.state.orderData.shoulder_type.label != ADVANCED_DEFAULTS.shoulder_type) {
            selected.push({
                label: "Shoulder: " + VAR_MAP.shoulder_type[suit.jacket.state.orderData.shoulder_type.label],
                price: suit.jacket.state.orderData.shoulder_type.price,
            });
            jacketKeys.push("Shoulder");
        }
        selected.push({
            label: "Vents: " + VAR_MAP.vents[suit.jacket.state.orderData.vents.label],
            price: suit.jacket.state.orderData.vents.price,
        });
        jacketKeys.push("Vents");
        if (suit.jacket.state.orderData.monogram) {
            if (suit.jacket.state.orderData.monogram.label == null) {
            } else if (suit.jacket.state.orderData.monogram.label == "null") {
            } else if (suit.jacket.state.orderData.monogram.label == "none") {
            } else if (suit.jacket.state.orderData.monogram.label == "None") {
            } else if (suit.jacket.state.orderData.monogram.label != "") {
                selected.push({
                    label: "Monogram: " + suit.jacket.state.orderData.monogram.label,
                    price: suit.jacket.state.orderData.monogram.price,
                });
                jacketKeys.push("Monogram");
            }
        }
        if (suit.pants.state.colors) {
            selected.push({
                label: "Pleats: " + VAR_MAP.pleats[suit.pants.state.orderData.pleats.label],
                price: suit.pants.state.orderData.pleats.price,
            });
            selected.push({
                label: "Suspender Buttons: " + VAR_MAP.suspender_buttons[suit.pants.state.orderData.suspender_buttons.label],
                price: suit.pants.state.orderData.suspender_buttons.price,
            });
            if (!suit.pants.state.orderData.waist_band) {
                suit.pants.state.orderData.waist_band = {
                    label: "side_tabs",
                    price: {
                        valueEUR: "",
                        valueUSD: "",
                    },
                };
            }
            selected.push({
                label: "Waistband: " + VAR_MAP.waist_band[suit.pants.state.orderData.waist_band.label],
                price: suit.pants.state.orderData.waist_band.price,
            });
            selected.push({
                label: "Dinner Split: " + VAR_MAP.dinner_split[suit.pants.state.orderData.dinner_split.label],
                price: suit.pants.state.orderData.dinner_split.price,
            });
            selected.push({
                label: "Pants Pockets: " + VAR_MAP.side_pockets[suit.pants.state.orderData.side_pockets.label],
                price: suit.pants.state.orderData.side_pockets.price,
            });
            selected.push({
                label: "Rear Pockets: " + VAR_MAP.rear_pockets[suit.pants.state.orderData.rear_pockets.label],
                price: suit.pants.state.orderData.rear_pockets.price,
            });
            selected.push({
                label: "Hem: " + VAR_MAP.hem[suit.pants.state.orderData.hem.label],
                price: suit.pants.state.orderData.hem.price,
            });
            if (suit.pants.state.orderData.hem.label !== "unhemmed") {
                selected.push({
                    label: "Length: " + VAR_MAP.length[suit.pants.state.orderData.length.label],
                    price: suit.pants.state.orderData.length.price,
                });
            }
            if (isTuxedo()) {
                if (suit.pants.state.orderData.tuxedo_stripes.label == "with") {
                    selected.push({
                        label: "Tuxedo Stripe: Yes",
                        price: suit.pants.state.colors.VIII.pricing,
                    });
                } else {
                    selected.push({
                        label: "Tuxedo Stripe: No",
                        price: {
                            valueEUR: "",
                            valueUSD: "",
                        },
                    });
                }
            }
        } else {
            if (pantsDefaultData.length > 0) {
                pantsDefaultData.forEach((obj) => {
                    selected.push(obj);
                });
            } else {
                selected.push({
                    label: "Pants: Default selections",
                    price: {
                        valueUSD: "",
                        valueEUR: "",
                    },
                });
            }
        }
        return selected;
    }

    function isTuxedo() {
        return suit.jacket.state.orderData["sartorotuxedo"] || window.location.href.includes("tuxedo");
    }

    function registerIframeListener() {
        const iframe = document.getElementById("konfigurator");
        if (!iframe) return;

        window.addEventListener("resize", () => {
            iframe.style.top = "0px";
            iframe.style.bottom = "0px";
            iframe.style.left = "0px";
            iframe.style.right = "0px";
        });

        window.addEventListener("modalDT3o::open", () => {
            konfigurator = true;
            toggleKonfigurator();
        });

        if (utils.getProductUrl()) {
            if (!window.KONFIGURATOR_JUMP_SUIT) {
                iframe.src = utils.getProductUrl();
            } else {
                iframe.src = window.KONFIGURATOR_JUMP_SUIT.jacket;
            }
        } else {
            iframe.src = `https://3dk.tronog-engine.com/konfigurator/?id=Sartoro/Jacket&q=17b62586-110d-4d5d-95bf-5028298afd57&pid=${productId}`;
        }
    }

    function toggleKonfigurator(event) {
        konfigurator = !konfigurator;
        console.log("toggleKonfigurator::", konfigurator);

        const iframe = getIframeElement();
        const body = document.body;
        const html = document.documentElement;

        body.style.overflowY = konfigurator ? "hidden" : "";
        html.style.overflowY = konfigurator ? "hidden" : "";

        body.style.height = konfigurator ? `${window.innerHeight}px` : "";
        html.style.height = konfigurator ? `${window.innerHeight}px` : "";

        iframe.classList.toggle("maximized", konfigurator);
        iframe.classList.toggle("hidden", !konfigurator);

        html.classList.toggle("noscroll", konfigurator);
        body.classList.toggle("noscroll", konfigurator);
        body.classList.toggle("konfigurator-iframe-shown", konfigurator);
        // setImage();

        // Nguyen added start
        sendDefaultSelection();
        // Nguyen added end

        if (event) {
            event.preventDefault();
        }
        return false;
    }

    function setImage() {
        window.dispatchEvent(
            new CustomEvent("konfigurator:imageUpdated", {
                detail: {
                    src: imageSrc,
                },
            })
        );
    }

    function getIframeElement() {
        return document.getElementById("konfigurator");
    }

    function getMapGarment(garment) {
        const garmentData = {};
        const checkKeys = [];
        const garmentOptions = garment || [];

        garmentOptions.forEach((item) => {
            if (!item || !item.title) return;

            const titleParts = item.title.split(" | ");
            if (titleParts.length < 2) return;

            let currentObj = garmentData;

            for (let i = 0; i < titleParts.length - 2; i++) {
                const key = titleParts[i].toLowerCase().replace(/\s+/g, "_");

                if (!currentObj[key]) {
                    currentObj[key] = {};
                    if (!checkKeys.includes(key)) {
                        checkKeys.push(key);
                    }
                }
                currentObj = currentObj[key];
            }

            const finalKey = titleParts[titleParts.length - 2].toLowerCase().replace(/\s+/g, "_");
            const finalValue = titleParts[titleParts.length - 1];

            currentObj[finalKey] = finalValue;
        });
        return garmentData;
    }

    // Nguyen added start
    function getDataJsonMtf() {
        const { type, jacket, pants, vest, buttons, lining, satin, pipping_buttonhole } = product_default_mtf;
        const data = {
            id: product.id,
            sku: product_default_mtf.sku,
            type,
        };
        let mapJacket = {};
        let mapPants = {};
        let mapVest = {};
        switch (type) {
            case "Suit":
                mapJacket.jacket = getMapGarment(jacket);
                mapPants.pants = getMapGarment(pants);
                mapVest.vest = getMapGarment(vest);
                return {
                    ...data,
                    ...mapJacket,
                    ...mapPants,
                    ...mapVest,
                    buttons,
                    pipping_buttonhole,
                    lining,
                    satin,
                };
            case "Jacket":
                mapJacket.jacket = getMapGarment(jacket);
                return {
                    ...data,
                    ...mapJacket,
                    buttons,
                    pipping_buttonhole,
                    lining,
                    satin,
                };

            case "Pants":
                mapPants.pants = getMapGarment(pants);
                return {
                    ...data,
                    ...mapPants,
                    buttons,
                };
            case "Vest":
                mapVest.vest = getMapGarment(vest);
                return {
                    ...data,
                    ...mapVest,
                    buttons,
                    lining,
                    satin,
                };
            default:
                return null;
        }
    }
    // Nguyen added end

    function onOrderClick(event) {
        try {
            setTimeout(() => {
                // wait 300ms to iframe load latest data
                konfigurator = false;
                const mainProductForm = document.querySelector("product-cart-form-bcpo");
                const submitButton = mainProductForm.querySelector("[name=add]") || mainProductForm.querySelector(".add-to-cart");
                if (submitButton) {
                    submitButton.removeAttribute("disabled");
                    submitButton.click();
                }
            }, 300);
        } catch (e) {
            console.log(e);
        }
    }

    function resetSelection() {
        const iframe = getIframeElement();

        iframe.contentWindow.postMessage(
            {
                action: "resetselection",
                data: {},
            },
            "*"
        );
    }

    function resetAllSelection() {
        const iframe = getIframeElement();

        iframe.contentWindow.postMessage(
            {
                action: "resetallselection",
                data: {},
            },
            "*"
        );
    }

    function resetAllSelections() {
        const iframe = getIframeElement();

        iframe.contentWindow.postMessage(
            {
                action: "resetallselection",
                data: {},
            },
            "*"
        );
    }

    function snapshot() {
        const iframe = getIframeElement();

        iframe.contentWindow.postMessage(
            {
                action: "snapshot",
                data: {},
            },
            "*"
        );
    }

    // Nguyen added start
    function sendDefaultSelection() {
        const iframe = getIframeElement();
        const dataMtf = getDataJsonMtf();

        if (!dataMtf) return;

        console.log(dataMtf, "==-dataMtf");
        iframe.contentWindow.postMessage(
            {
                action: "sendDefaultSelection",
                data: dataMtf,
            },
            "*"
        );
    }
    // Nguyen added end

    function onSnapshot(data) {}

    function getMarketPrice(price) {
        try {
            if (window.tronog_pricing) {
                return window.tronog_pricing.getPrice(price);
            }
            return price;
        } catch (e) {
            console.error(e);
            return price;
        }
    }

    function parseMessage(message) {
        if (!message.origin.includes("tronog-engine.com")) return;

        if (window.KONFIGURATOR_RESET_ALL_SELECTIONS) {
            window.KONFIGURATOR_RESET_ALL_SELECTIONS = false;
            resetAllSelections();
            return;
        }

        switch (message.data.action) {
            case "goback":
                handleGoBack();
                break;

            case "onsnapshot":
                window.konfigurator.onSnapshot(message.data);
                break;

            case "save":
                renderProductProperties();
                handleSaveAction(message);
                break;

            case "hideorderbutton":
                toggleOrderButtonVisibility(true);
                break;

            case "showorderbutton":
                toggleOrderButtonVisibility(false);
                break;

            case "order":
                onOrderClick();
                break;

            case "exit":
                toggleKonfigurator();
                renderProductProperties();
                break;

            case "state":
                if (message.data.data) {
                    state = message.data.data;
                    parseState(message);
                    renderProductProperties(); // need for buy now button in iframe
                }
                break;

            default:
                if (!message.data.action || !message.data.data) return;
        }
    }

    function handleGoBack() {
        if (suit.phase === "pants") {
            const iframe = getIframeElement();
            iframe.style.background = "#fff";
            const jacketUrl = window.KONFIGURATOR_JUMP_SUIT ? window.KONFIGURATOR_JUMP_SUIT.jacket : window.konfigurator_data.SUIT_MAP[productHandle].jacket;
            iframe.src = `${jacketUrl}&multistage=first`;
            suit.phase = "jacket";
        }
    }

    function handleSaveAction(message) {
        try {
            if (getProductType !== "suit") {
                message.data.action = "order";
                return;
            }

            if (suit.phase === "jacket") {
                handleJacketPhase();
            } else if (suit.phase === "pants") {
                handlePantsPhase();
            }
        } catch (e) {
            console.error(e);
        }
    }

    function handleJacketPhase() {
        const iframe = getIframeElement();
        iframe.style.background = "#fff";

        const isTuxedo = suit.jacket.state.orderData["sartorotuxedo"] || window.location.href.includes("tuxedo");
        const tuxedoMat = suit.jacket.state.colors.VI.selected;

        setTimeout(() => {
            const pantsUrl = window.KONFIGURATOR_JUMP_SUIT ? window.KONFIGURATOR_JUMP_SUIT.pants : window.konfigurator_data.SUIT_MAP[productHandle].pants;

            iframe.src = isTuxedo
                ? `${pantsUrl}&multistage=last&menu_XXVII=true&menu_XXVIII=false&var_tuxedo_stripes=with&mat_VIII=${tuxedoMat}`
                : `${pantsUrl}&multistage=last`;

            // setImage();
            suit.phase = "pants";
        }, 3000);
    }

    function handlePantsPhase() {
        suit.phase = "jacket";
        konfigurator = false;
        const addButton = document.querySelectorAll("[name=add]")[0] || document.querySelectorAll(".add-to-cart")[1];
        addButton?.click();
    }

    function toggleOrderButtonVisibility(hide) {
        const orderButton = document.getElementById("konfiguratororder");
        if (orderButton) {
            orderButton.classList.toggle("hidden", hide);
        }
    }

    async function parseState(message) {
        // Ensure activeMaterialLinks is a Set
        state.activeMaterialLinks = new Set(state.activeMaterialLinks);

        // Handle suit state
        if (getProductType === "suit") {
            suit[suit.phase].state = state;
        }

        // Process current image
        if (state.currentImage && !state.currentImage.includes("null") && !state.currentImage.includes("undefined")) {
            const _imageSrc = state.currentImage.replace(/_F(\d{2})/g, "_F01");
            if (getProductType !== "suit" || suit.phase === "jacket") {
                imageSrc = _imageSrc;
            }
            state.currentImage = _imageSrc;
        }

        // Update original price
        if (window.KONFIGURATOR_STATE_ORIGINAL_PRICE) {
            console.log("window.KONFIGURATOR_STATE_ORIGINAL_PRICE :>> ", window.KONFIGURATOR_STATE_ORIGINAL_PRICE);
            originalPrice = parseFloat(window.KONFIGURATOR_STATE_ORIGINAL_PRICE);
        }

        let price = originalPrice;
        // Calculate roots
        const roots = {};
        const list = state?.geometries ? Object.keys(state?.geometries).sort() : [];
        list.forEach((key) => {
            const root = key.split("_").slice(0, -1).join("_") + "_" + key.split("_").slice(-1)[0][0];
            roots[root] = (roots[root] || 0) + 1;
        });

        // Get selected items and update price
        selected = [];

        if (getProductType != "suit") {
            let result = getSelectedItems(selected, price, state.colors, state.activeMaterialLinks, state.orderData);
            selected = result.selected;
            price = result.price;
        } else {
            if (suit.jacket.state) {
                let result = getSelectedItems(selected, price, suit.jacket.state.colors, suit.jacket.state.activeMaterialLinks, suit.jacket.state.orderData);
                selected = result.selected;
                price = result.price;
            } else {
                let result = getSelectedItems(selected, price, state.colors, state.activeMaterialLinks, state.orderData);
                selected = result.selected;
                price = result.price;
            }
            if (suit.pants.state && suit.pants.state.colors) {
                result = getSelectedItems(selected, price, suit.pants.state.colors, suit.pants.state.activeMaterialLinks, suit.pants.state.orderData);
                selected = result.selected;
                price = result.price;
            }
        }

        if (window.KONFIGURATOR_STATE_PRICE && !window.KONFIGURATOR_STATE_PRICE_UPDATED) {
            price = parseFloat(window.KONFIGURATOR_STATE_PRICE);
            window.KONFIGURATOR_STATE_PRICE_UPDATED = true;
        }

        state.updatedPrice = price;
        await storeLocal(price);

        if (exported.onMessage(message)) {
            return;
        }
    }

    function setProductDetails(productDetails) {
        if (getProductType == "suit") {
            suit = productDetails;
            suit.jacket.state.activeMaterialLinks = new Set(suit.jacket.state.activeMaterialLinks);
            suit.pants.state.activeMaterialLinks = new Set(suit.pants.state.activeMaterialLinks);
            state = suit.jacket.state;
            suit.phase = "jacket";
        } else {
            state = productDetails;
        }
        parseState({ data: { data: state } });
        storeLocal();
    }

    async function storeLocal(price) {
        if (getProductType == "suit") {
            let _jacketState = { ...suit["jacket"].state };
            let _pantsState = { ...suit["pants"].state };

            if (typeof _jacketState.activeMaterialLinks == "object") {
                _jacketState.activeMaterialLinks = Array.from(_jacketState.activeMaterialLinks);
            }

            if (typeof _pantsState.activeMaterialLinks == "object") {
                _pantsState.activeMaterialLinks = Array.from(_pantsState.activeMaterialLinks);
            }

            await window.theme.set(
                "sartoro_suit_" + productHandle,
                JSON.stringify({ jacket: { state: _jacketState }, pants: { state: _pantsState }, price: price }),
                window.arnDaysUntilExpiry
            );

            const imagesSrc = [];
            if (_jacketState.currentImage) imagesSrc.push(_jacketState.currentImage);
            if (_pantsState.currentImage) imagesSrc.push(_pantsState.currentImage);

            window.dispatchEvent(
                new CustomEvent("konfigurator:imageUpdated", {
                    detail: {
                        src: imagesSrc,
                    },
                })
            );

            document.body.classList.add("btn-configure--has-edited");

            exported.onProductDetails(suit);
        } else {
            let _state = { ...state };
            _state.activeMaterialLinks = Array.from(_state.activeMaterialLinks);

            await window.theme.set("sartoro_" + productHandle, JSON.stringify(_state), window.arnDaysUntilExpiry);

            const imagesSrc = [];
            if (_state.currentImage) imagesSrc.push(_state.currentImage);

            window.dispatchEvent(
                new CustomEvent("konfigurator:imageUpdated", {
                    detail: {
                        src: imagesSrc,
                    },
                })
            );

            document.body.classList.add("btn-configure--has-edited");

            exported.onProductDetails(state);
        }
    }

    function getSelectedItems(selected, price, colors, activeMaterialLinks, orderData) {
        let _selected = [...selected];
        let additional = 0;

        list = colors ? Object.keys(colors) : [];
        active = activeMaterialLinks;
        for (let key of list) {
            if (!key) {
                continue;
            }

            if (!active.has(key)) {
                continue;
            }

            let item = colors[key];
            try {
                if (!IGNORE[colors[key].label]) {
                    // if ((getProductType != "suit") && (colors[key].label == "MainMat_OR_Satin")) {
                    //   continue;
                    // }

                    additional += Number(item.pricing.valueUSD);
                    price += Number(item.pricing.valueUSD) * 100;
                }
            } catch (e) {
                //
            }

            _selected.push({
                label: item.label + ": " + item.selectedLabel,
                price: (item.pricing.valueUSD * 100).toString(),
            });
        }

        list = orderData ? Object.keys(orderData) : [];
        for (let key of list) {
            if (key == "sartorotuxedo") {
                continue;
            }
            let item = orderData[key];

            if (key == "monogram") {
                if (item.label == "") {
                    continue;
                }
                if (item.label == "null") {
                    continue;
                }
            }

            try {
                if (typeof item.price.valueUSD != "undefined") {
                    additional += Number(item.price.valueUSD);
                    price += Number(item.price.valueUSD) * 100; //NTH - update price 052724
                }
            } catch (e) {
                //
            }
        }

        return { selected: _selected, price: price };
    }

    function getState() {
        let _selected = selected;
        selected = [];
        _selected.forEach((item) => {
            let variable = item.label.split(": ")[0];
            let value = item.label.split(": ")[1].split("|")[0];

            if (IGNORE[variable]) {
                return;
            }
            if (REPLACEMENTS[variable]) {
                variable = REPLACEMENTS[variable];
            }
            item.label = variable + ": " + value;
        });

        selected = generateCartItems(_selected);

        const properties = selected
            .map((item) => {
                if (!item) {
                    return null;
                }
                let variable = item.label.split(": ")[0].split("|")[0];
                let price = "";

                if (item.price) {
                    if (typeof item.price.valueUSD != "undefined") {
                        if (item.price.valueUSD) {
                            price = " | $" + item.price.valueUSD + ".00";
                        }
                    } else {
                        if (item.price) {
                            price = " | $" + item.price + ".00";
                        }
                    }
                }
                let value = item.label.split(": ")[1] + price;

                if (item.label.split(": ")[0]) {
                    return {
                        key: variable,
                        value,
                    };
                }
                return null;
            })
            .filter(Boolean);

        const obj = {
            properties,
            updatedPrice: state.updatedPrice,
        };

        window.dispatchEvent(
            new CustomEvent("konfigurator:updated", {
                detail: obj,
            })
        );

        return obj;
    }

    function renderProductProperties() {
        const container = document.getElementById("konfiguratorProperties");
        const buyButton = document.querySelector("[data-atc]");
        const { properties } = getState();

        if (!container || !buyButton || properties.length == 0) return;

        const _jacketKeys = [...new Set(jacketKeys)].join("|").toLowerCase().split("|");

        const cartItems = generateCartItems([]);

        window.dispatchEvent(
            new CustomEvent("konfigurator:render-data", {
                detail: {
                    cartItems: cartItems,
                    trigger: false,
                    productType: getProductType,
                    jacketKeys: _jacketKeys,
                },
            })
        );

        const formId = buyButton.form.getAttribute("id");

        function capitalizeWords(str) {
            return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
        }

        let html = properties
            .map(({ key, value }) => {
                const keyLowerCase = key.toLowerCase();
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = `properties[${key}]`;
                input.value = value;
                input.setAttribute("form", formId);
                // if (getProductType === "suit") {
                //     if (key == "Pants" && value == "Default selections") {
                //         input.name = `properties[Pants - ${key}]`;
                //     } else {
                //         const isJacketKey = _jacketKeys.findIndex((jacketKey) => jacketKey == keyLowerCase);
                //         if (isJacketKey != -1) {
                //             input.name = `properties[Jacket - ${key}]`;
                //         } else {
                //             input.name = `properties[Pants - ${key}]`;
                //         }
                //     }
                // } else {
                //     input.name = `properties[${capitalizeWords(getProductType)} - ${key}]`;
                // }
                return input.outerHTML;
            })
            .join("");

        container.innerHTML = html;
    }

    init();

    return exported;
};

document.addEventListener("DOMContentLoaded", async (event) => {
    if (!window.KONFIGURATOR_IGNORE_PRODUCT_DETAILS) {
        STATE_SUIT = await window.theme.get("sartoro_suit_" + productHandle);
        if (window.KONFIGURATOR_STATE) STATE_SUIT = window.KONFIGURATOR_STATE;
        STATE_PRODUCT = await window.theme.get("sartoro_" + productHandle);
    }

    if (["product", "cart"].includes(currentPageType) || window.location.href.includes("/pages/customize-garments")) {
        if (window.konfigurator_data) {
            const params = new URLSearchParams(window.location.search);

            if (params.has("dev")) {
                let interval = setInterval(() => {
                    if (typeof KonfiguratorDEV != "undefined") {
                        clearInterval(interval);
                        window.konfigurator = KonfiguratorDEV(STATE_SUIT, STATE_PRODUCT);
                    }
                }, 100);
            } else {
                window.konfigurator = Konfigurator(STATE_SUIT, STATE_PRODUCT);
            }
        }
    }
});

if (["product", "cart"].includes(currentPageType) || window.location.href.includes("/pages/customize-garments")) {
    setTimeout(function () {
        if (window.konfigurator && typeof window.konfigurator.toggleKonfigurator === "undefined") {
            window.konfigurator = Konfigurator(STATE_SUIT, STATE_PRODUCT);
        }
    }, 6000);
}

try {
    const TronogPricingFactory = (base, target, conversionRateFactor) => {
        const marketMap = {
            international: "us",
            australia: "au",
            slovenia: "eu",
        };
        const rateMap = {
            eu: {
                price: 10000.0,
                conversionRateFactor: 1.0,
            },
            us: {
                price: 11265.0,
                conversionRateFactor: 1.02,
            },
            au: {
                price: 16886.0,
                conversionRateFactor: 1.02,
            },
        };
        let targetMarket = "us";
        if (marketMap[target]) {
            targetMarket = marketMap[target];
        }
        let baseMarket = "us";
        if (marketMap[target]) {
            baseMarket = marketMap[target];
        }
        let rate =
            (rateMap[targetMarket].price /
                rateMap[targetMarket].conversionRateFactor /
                (rateMap[baseMarket].price / rateMap[baseMarket].conversionRateFactor)) *
            conversionRateFactor;
        if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
            console.log("TronogPricingFactory using Shopify client data:", window.Shopify.currency);
            rate = +window.Shopify.currency.rate;
        } else {
            getRates();
        }
        console.log("TronogPricing v1.0.101a", base, target, rate);
        const getPrice = (originalPrice) => {
            const result = Math.round(originalPrice * rate * 100) / 100;
            console.log("Converted price:", originalPrice, result);
            return result;
        };
        const getRates = () => {
            fetch("https://3dk.tronog-engine.com/api/currency/getrate", (response) => {});
        };
        return {
            getPrice,
        };
    };
    window.tronog_pricing = TronogPricingFactory("us", window.KONFIGURATOR_MARKET, 1);
} catch (e) {
    console.error(e);
}
